<aux-workflow-panel
  *ngIf="(isQuarterCloseEnabled$ | async) && (isClosingPanelEnabled$ | async)"
  [className]="'mb-4'"
  [workflowName]="workflowName"
  [isAdminUser]="(isAdminUser$ | async) === true"
  [processing]="(isCloseMonthsProcessing$ | async)!"
></aux-workflow-panel>

<aux-investigator-transactions-header
  [isContractSelected$]="isContractSelected$"
  [gridAPI]="gridAPI"
  [columnAPI]="columnAPI"
>
</aux-investigator-transactions-header>

<div class="flex">
  <aux-investigator-transactions-filters
    class="flex-1"
    [filterLoading$]="filterLoading$"
    (transactionFilterChange)="transactionFilterChange($event)"
  >
  </aux-investigator-transactions-filters>

  <div class="flex flex-col-reverse">
    <aux-button
      *auxAuthorize="{ sysAdminsOnly: true }"
      variant="secondary"
      label="Import Patient Data"
      classList="mb-4"
      [disabled]="isPatientsFinalized$ | async"
      [onClick]="openImportPatientDataModal.bind(this)"
      [auxTooltip]="importPatientDataTooltip(isPatientsFinalized$ | async)"
    ></aux-button>
  </div>
</div>

<ng-container *ngIf="(gridRefresh$ | async) === false">
  <ag-grid-angular
    class="ag-theme-aux mb-8 tabular-nums w-full"
    domLayout="autoHeight"
    [gridOptions]="$any(gridOptions$ | async)"
    (gridReady)="onGridReady($event)"
    (gridSizeChanged)="gridSizeChanged()"
    (viewportChanged)="onWindowScroll()"
  >
  </ag-grid-angular>
  <aux-pagination-panel
    *ngIf="!!gridAPI?.getRenderedNodes()?.length"
    [gridApi]="gridAPI"
    [totalItems]="(totalItems$ | async)!"
  ></aux-pagination-panel>
</ng-container>

<ng-container *ngIf="(gridRefresh$ | async) === true">
  <div class="border-8 h-32 m-auto mt-40 spinner w-32"></div>
</ng-container>
